import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { IStation } from "Types/station";

interface IState {
  stations: IStation[];
  ids: number[];
  visible: boolean;
  distance: number;
  visibleStationDashboard: boolean;
  starStation: any;
}

const initialState: IState = {
  stations: [],
  ids: [],
  visible: false,
  distance: 0,
  visibleStationDashboard: false,
  starStation: {},
};

export const trafficStationsSlice = createSlice({
  name: "trafficStations",
  initialState,
  reducers: {
    setStations: (state, action: PayloadAction<IStation[]>) => {
      const newStations = action.payload;
      const ids = newStations.map((station) => station.id);

      return { ...state, stations: newStations, ids };
    },
    selectStation: (state, action: PayloadAction<IStation>) => {
      if (state.ids.includes(action.payload.id)) return { ...state };
      const newStations = [...state.stations, { ...action.payload }];
      const ids = newStations.map((station) => station.id);

      return { ...state, stations: [...state.stations, { ...action.payload }], ids };
    },
    deselectStation: (state, action: PayloadAction<number>) => {
      const newStations = state.stations.filter((station) => station.id !== action.payload);
      const ids = newStations.map((station) => station.id);

      return { ...state, stations: newStations, ids };
    },
    clearStations: (state) => {
      return { ...state, stations: [], ids: [] };
    },
    setDistance: (state, action: PayloadAction<number>) => {
      return { ...state, distance: action.payload };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    selectStationStar: (state, action: PayloadAction<any>) => {
      return { ...state, visibleStationDashboard: action.payload.visible, starStation: action.payload.starStation };
    },
  },
});

export const {
  setStations,
  selectStation,
  deselectStation,
  clearStations,
  toggleVisibility,
  setDistance,
  makeInvisible,
  selectStationStar,
} = trafficStationsSlice.actions;

export default trafficStationsSlice.reducer;
